import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-pill px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground",
        accent:
          "bg-accent text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground",
        soft:
          "bg-surface-soft text-accent font-medium",
        outline:
          "border border-border text-foreground bg-transparent",
        destructive:
          "bg-destructive text-destructive-foreground",
        success:
          "bg-green-50 text-green-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({ className, variant, ...props }) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
